import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FaUserCircle, FaUserPlus, FaGlobe, FaBars, FaTimes } from 'react-icons/fa';


export default function Header({ language = "en", onLanguageChange = () => {} }) {
  const [showLanguages, setShowLanguages] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const langOptions = [
    { code: 'en', label: 'English', flag: '/assets/images/Header/flag-usa.png' },
    { code: 'es', label: 'Español', flag: '/assets/images/Header/flag-spain.png' },
    { code: 'pt', label: 'Português', flag: '/assets/images/Header/flag-brazil.png' },
  ];

  const getText = (key) => {
    const texts = {
      home: { en: 'Home', es: 'Inicio', pt: 'Início' },
      about: { en: 'About us', es: 'Sobre Nosotros', pt: 'Sobre Nós' },
      how: { en: 'How it works', es: 'Cómo funciona', pt: 'Como funciona' },
      faq: { en: 'FAQ', es: 'Preguntas', pt: 'Perguntas' },
      contact: { en: 'Contact', es: 'Contacto', pt: 'Contato' },
      register: { en: 'Register', es: 'Registrarse', pt: 'Registrar' },
      login: { en: 'Login', es: 'Iniciar sesión', pt: 'Entrar' },
    };
    return texts[key][language];
  };

  const handleCloseMenus = () => {
    setShowMobileMenu(false);
    setShowLanguages(false);
  };

  const scrollOrNavigate = (id) => {
    if (location.pathname === '/') {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate(`/#${id}`);
    }
  };

  const handleLogoClick = () => {
    if (location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/');
    }
  };

  const handleAboutClick = () => {
    if (location.pathname === '/about') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/about');
    }
  };

  return (
    <header className="w-full bg-white shadow-md fixed top-0 z-50">
      <div className="max-w-screen-2xl mx-auto px-4 py-3 flex items-center justify-between relative">
        {/* Logo */}
        <button
          onClick={handleLogoClick}
          className="p-0 m-0 border-none bg-transparent focus:outline-none"
          aria-label="Inicio"
        >
          <img
            src="/assets/images/Header/logoregularcolor.png"
            alt="YourLostAndFound Logo"
            className="h-10 sm:h-12 md:h-14 lg:h-16 object-contain"
          />
        </button>

        {/* Iconos y menú principal */}
        <div className="hidden md:flex flex-col items-end justify-between" style={{ height: 'auto' }}>
       <div className="flex space-x-4 mb-[15px]">
  <button onClick={() => setShowLanguages(!showLanguages)} aria-label="Seleccionar idioma">
    <FaGlobe className="text-2xl text-gray-600 hover:text-turquoise-600 transition-transform hover:scale-110" />
  </button>
  <button onClick={() => navigate('/waitlist')} aria-label="Registrarse">
    <FaUserPlus className="text-2xl text-gray-600 hover:text-turquoise-600 transition-transform hover:scale-110" />
  </button>
  <button onClick={() => navigate('/waitlist')} aria-label="Iniciar sesión">
    <FaUserCircle className="text-2xl text-gray-600 hover:text-turquoise-600 transition-transform hover:scale-110" />
  </button>
</div>
          <nav className="flex space-x-6 text-sm font-medium text-gray-700">
            <button onClick={handleLogoClick} className="hover:text-turquoise-600 hover:underline bg-transparent border-none p-0 m-0">{getText('home')}</button>
            <button onClick={handleAboutClick} className="hover:text-turquoise-600 hover:underline bg-transparent border-none p-0 m-0">{getText('about')}</button>
            <button onClick={() => scrollOrNavigate('how')} className="hover:text-turquoise-600 hover:underline bg-transparent border-none p-0 m-0">{getText('how')}</button>
            <button onClick={() => scrollOrNavigate('faq')} className="hover:text-turquoise-600 hover:underline bg-transparent border-none p-0 m-0">{getText('faq')}</button>
            <Link to="/contact" className="hover:text-turquoise-600 hover:underline">{getText('contact')}</Link>
          </nav>
        </div>

        {/* Menú desplegable de idiomas */}
        {showLanguages && (
          <div className="absolute top-16 right-4 bg-white/80 backdrop-blur-md border border-gray-300 rounded shadow-md p-2 transition-all duration-300 ease-in-out transform origin-top scale-y-100 opacity-100 z-50">
            {langOptions.map((option) => (
              <div
                key={option.code}
                className="flex items-center space-x-2 p-2 hover:bg-gray-100 cursor-pointer"
                onClick={() => {
                  onLanguageChange(option.code);
                  setShowLanguages(false);
                }}
              >
                <img src={option.flag} alt={option.label} className="h-4 w-6 object-cover" />
                <span>{option.label}</span>
              </div>
            ))}
          </div>
        )}

        {/* Botón hamburguesa (mobile) */}
        <div className="md:hidden flex items-center">
          <button onClick={() => setShowMobileMenu(!showMobileMenu)} aria-label="Abrir menú">
            {showMobileMenu ? (
              <FaTimes className="text-3xl text-gray-700 transition-transform duration-300 transform rotate-90" />
            ) : (
              <FaBars className="text-3xl text-gray-700 transition-transform duration-300" />
            )}
          </button>
        </div>

        {/* Drawer menú mobile */}
        <div className={`fixed inset-y-0 right-0 bg-white/80 backdrop-blur-md border-l border-gray-300 w-64 p-6 flex flex-col justify-between text-gray-700 text-sm transform transition-transform duration-300 ease-in-out overflow-x-hidden ${showMobileMenu ? 'translate-x-0' : 'translate-x-full'}`}>

          {/* Contenido principal de navegación */}
          <div className="flex flex-col space-y-6">
            <button 
              onClick={handleCloseMenus}
              aria-label="Cerrar menú"
              className="self-end mb-4 w-10 h-10 flex items-center justify-center"
            >
              <FaTimes className="text-3xl text-gray-700 hover:text-turquoise-600 transition-transform hover:scale-110" />
            </button>

            <button onClick={() => { handleLogoClick(); handleCloseMenus(); }} className="hover:text-turquoise-600 hover:underline text-left">{getText('home')}</button>
            <button onClick={() => { handleAboutClick(); handleCloseMenus(); }} className="hover:text-turquoise-600 hover:underline text-left">{getText('about')}</button>
            <button onClick={() => { scrollOrNavigate('how'); handleCloseMenus(); }} className="hover:text-turquoise-600 hover:underline text-left">{getText('how')}</button>
            <button onClick={() => { scrollOrNavigate('faq'); handleCloseMenus(); }} className="hover:text-turquoise-600 hover:underline text-left">{getText('faq')}</button>
            <Link to="/contact" onClick={handleCloseMenus} className="hover:text-turquoise-600 hover:underline">{getText('contact')}</Link>
          </div>

          {/* Botones de acceso rápido al fondo */}
        <div className="flex space-x-4 pt-6 border-t border-gray-300">
		  <button onClick={() => { navigate('/waitlist'); handleCloseMenus(); }} aria-label="Registrarse">
			<FaUserPlus className="text-2xl text-gray-600 hover:text-turquoise-600 transition-transform hover:scale-110" />
		  </button>
		  <button onClick={() => { navigate('/waitlist'); handleCloseMenus(); }} aria-label="Iniciar sesión">
			<FaUserCircle className="text-2xl text-gray-600 hover:text-turquoise-600 transition-transform hover:scale-110" />
		  </button>
		  <button onClick={() => setShowLanguages(!showLanguages)} aria-label="Seleccionar idioma">
			<FaGlobe className="text-2xl text-gray-600 hover:text-turquoise-600 transition-transform hover:scale-110" />
		  </button>
		</div>


        </div>

      </div>
    </header>
  );
}
